import { render } from "./NavBarFooter.vue?vue&type=template&id=747134b5&scoped=true"
import script from "./NavBarFooter.vue?vue&type=script&lang=js"
export * from "./NavBarFooter.vue?vue&type=script&lang=js"

import "./NavBarFooter.vue?vue&type=style&index=0&id=747134b5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-747134b5"]])

export default __exports__